import { skyFoundationSettings } from '../../../services/configs/configs-service';
import { buildUrlWithQueryParams } from '../../../utils/build-urls';

const BASE_URL = skyFoundationSettings.getPlaylistBaseUrl();

export const getPlaylistData = async (playlistID) => {
  let playlistDataBaseUrl = '';
  const queryStringObj = {
    id: playlistID,
    count: 50,
    novp: 'no',
    free: 0,
    access_type: 0,
    hls: 'yes',
  };

  try {
    playlistDataBaseUrl = buildUrlWithQueryParams(`${BASE_URL}getPlaylistVideoData`, queryStringObj);
    const playlistData = await fetch(playlistDataBaseUrl);
    const parsedPlaylistData = await playlistData.json();
    return parsedPlaylistData.assets || [];
  } catch (error) {
    console.error('Error on fetching video playlist - ', error);
    return [];
  }
};

export const getPlaylistInfo = async (playlistID) => {
  let playlistInfoBaseUrl = '';
  const queryStringObj = {
    id: playlistID,
  };
  try {
    playlistInfoBaseUrl = buildUrlWithQueryParams(`${BASE_URL}getPlaylistInfo`, queryStringObj);
    const playlistInfo = await fetch(playlistInfoBaseUrl);
    const parsedPlaylistInfo = await playlistInfo.json();
    return parsedPlaylistInfo[0] || '';
  } catch (error) {
    console.error('Error on fetching video playlist INFO - ', error);
    return '';
  }
};
